import { ApiUrl } from 'src/constants';
import { httpService } from 'src/services';
import { IAppTranslationData } from 'src/store/requests/translations/reducer';
import { HydraResponse } from 'src/api/hydraResponse';

export function getTranslationRequestData(lang: string) {
  return httpService.get(`${ApiUrl.getApiUrl().getTranslationsById}&lang=${lang}`);
}

export function getAppTranslationRequestData(): Promise<HydraResponse<IAppTranslationData[]>> {
  return httpService.get(`${ApiUrl.getApiUrl().getAppTranslationsById}`);
}
